import React from "react";
import { ConfigProvider, Switch } from "antd";
import { useFormikContext, Field } from "formik";
import useThemeStore from "(store)/themeStore";

const SwitchField = ({
  name,
  label,
  isRequired = false,
  checkedChildren,
  unCheckedChildren,
  reverse,
  onChange, // Accept onChange as a prop
  disabled = false,
}) => {
  const theme = useThemeStore((state) => state.theme);
  const { setFieldValue } = useFormikContext();

  const switchColor = theme === "dark" ? "#FAB54E" : "#1996A6";

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: switchColor,
          colorBorder: switchColor,
          colorBorderChecked: switchColor,
        },
        components: {
          Switch: {
            colorPrimary: switchColor,
            colorBorder: switchColor,
            colorBorderChecked: switchColor,
          },
        },
      }}
    >
      <div
        className={`flex items-center gap-2  ${reverse && "flex-row-reverse"}`}
      >
        {label && (
          <span
            className={`label-text 
               dark:text-white text-gray-900
            mr-2 relative`}
          >
            {label}
            {isRequired && (
              <span className="text-red-500 font-extrabold">*</span>
            )}
          </span>
        )}
        <Field name={name}>
          {({ field }) => (
            <Switch
              {...field}
              checked={field.value}
              checkedChildren={checkedChildren}
              unCheckedChildren={unCheckedChildren}
              onChange={(checked) => {
                setFieldValue(name, checked);
                if (onChange) {
                  onChange(checked);
                }
              }}
              className={`${
                field.error && field.touched
                  ? "border-red-500"
                  : "border-gray-300"
              } ${
                theme === "dark"
                  ? "dark:bg-slate-950 dark:text-gray-300"
                  : "bg-gray-100 text-gray-900"
              } focus:outline-none`}
              disabled={disabled}
            />
          )}
        </Field>
      </div>
    </ConfigProvider>
  );
};

export default SwitchField;
